import { render, staticRenderFns } from "./CompleteNewPassword.vue?vue&type=template&id=61d0da3d&scoped=true"
import script from "./CompleteNewPassword.vue?vue&type=script&lang=js"
export * from "./CompleteNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0da3d",
  null
  
)

export default component.exports